module.exports = __webpack_public_path__ + "32f16083ef6ce903dce12944142d6a06.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Light.woff
// module id = 375
// module chunks = 0